import { Layout, Frame, Button, Page, Toast } from '@shopify/polaris';

import SearchCustomer from './Search.jsx';
import {useState, useEffect, useCallback} from 'react';
import { useHistory } from 'react-router-dom';
import CustomerForm from './Form.jsx';
import Api from '../../helpers/api';

const Customers = () => {

    const history = useHistory();
    const [customer, setCustomer] = useState(null);
    const [creating, setCreating] = useState(false);
    const [updating, setUpdating] = useState(false);
    const [loading, setLoading] = useState(false);
    const [toast, setToast] = useState({
        active: false,
        message: ''
    });

    const toastMarkup = toast.active ? (
        <Toast content={toast.message} duration={3000} onDismiss={() => { setToast({ message: '', active: false }) }} />
    ) : null;


    const assignCustomer = (customer, query) => {
        if (query) {
            const q = (new URLSearchParams({
                query: query,
            })).toString();
            history.push(`/customers/${customer.id}/orders?${q}`);
        } else {
            history.push(`/customers/${customer.id}/orders`);
        }
    }

    const pageTitle = () => {
        if (updating) {
            return 'Edit Customer';
        } else if (creating) {
            return 'Create New Customer';
        } else {
            return 'Customers';
        }
    }

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const success = urlParams.get('draft_success');

        if ( success ) {
            setToast({ message: 'The draft order was created', active: true })
        }
    }, []);

    const generateOpenCreditReport = useCallback(() => {
        setLoading(true);
        Api
            .generateOpenCreditReport()
            .then(() => {
                setToast({ message: 'You will receive report on your email address.', active: true })
            })
            .catch(() => {
                setToast({ message: 'Server error', active: true })
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    return (
        <Frame>
            <Page
                title={pageTitle()}
                primaryAction={
                    (!creating && !updating)
                        ? <Button  onClick={() => { setCreating(true) }} variant="primary">New Customer</Button>
                        : <Button onClick={() => { setCreating(false); setUpdating(false) }}>Go Back</Button>
                }
                secondaryActions={[
                    { content: 'Customers Credit Report', onAction: generateOpenCreditReport, loading: loading },
                    { content: 'Approve Customers', onAction: () => history.push('/customers/approve') },
                ]}
            >
                {(creating || updating) ? (
                    <Layout>
                        <Layout.Section>
                            <CustomerForm
                                customer={customer}
                                updating={false}
                                onCustomerCreated={customer => {
                                    assignCustomer(customer);
                                    setToast({ active: true, message: 'Customer Created' });
                                }}
                                creating={creating}
                            />
                        </Layout.Section>
                    </Layout>
                ) : (
                    <Layout>
                        <Layout.Section>
                            {<SearchCustomer
                                emptyStateAction={{
                                    content: "New Customer",
                                    onAction: () => setCreating(true)
                                }}
                                onCustomerSelect={(customer, query) => {
                                    assignCustomer(customer, query);
                                }}
                            />}
                        </Layout.Section>
                    </Layout>
                )}
            </Page>
            {toastMarkup}
        </Frame>
    );
}


export default Customers;
